export const bulkActionNotificationModalData = (data = []) => {
  const errorAlgos = data.filter((d) => d.success === false) || [];
  const totalErrorCount = errorAlgos.length;
  const hiddenErrorCount = totalErrorCount > 0 ? totalErrorCount - 1 : 0;
  let { message = '' } = errorAlgos[0] ? errorAlgos[0] : [];

  const errors = {
    message,
  };

  if (hiddenErrorCount) {
    errors.more = `${hiddenErrorCount} more`;
  }

  return {
    message: `Error occured in ${totalErrorCount} ${
      totalErrorCount > 1 ? 'algos' : 'algo'
    }`,
    errors,
  };
};

export const getFormattedBrokerSpecialName = (brokerName) => {
  if (brokerName === 'angel') {
    return 'AngelOne';
  }

  if (brokerName === 'forward-testing') {
    return `Forward Testing`;
  }

  return undefined;
};

export const getFormattedDisplayName = (brokerName, displayName) => {
  const specialDisplayName = getFormattedBrokerSpecialName(brokerName);

  if (brokerName === 'forward-testing') {
    return displayName || specialDisplayName;
  }

  return specialDisplayName || displayName || brokerName;
};

export const formatSetupBrokerlabel = (data = {}) => {
  const { clientId = '', name: brokerName = '', brokerInfo = {} } = data;

  const { displayName } = brokerInfo;

  const formattedDisplayName = getFormattedDisplayName(brokerName, displayName);

  return `${clientId} - ${formattedDisplayName}`;
};
